import { StyleSheet } from "react-native";

const style = StyleSheet.create({
  row: {
    flex: 1,
    justifyContent: "center",
  },
});

export { style };
